import React from 'react';
import { useTranslation } from "react-i18next";
import { SystemIcons, ComponentXS, ComponentM, ComponentS, ComponentTextStyle, COLORS, IconButton, TextButton as Button } from "@laerdal/life-react-components";
import {
    ChoseFileContainer,
    ChoseFileContainerText,
    AttachmentsContainer,
    AttachmentDetails,
    AttachmentHeader,
    Tooltip,
    InputRow
} from "../CaseFormPage.styles";

interface FileUploadSectionProps {
    files: File[];
    fileSizeOverLimit: boolean;
    fileInputRef: React.RefObject<HTMLInputElement>;
    onDragEnter: (e: React.DragEvent<HTMLDivElement>) => void;
    onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
    onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
    onDrop: (e: React.DragEvent<HTMLDivElement>) => void;
    onClick: () => void;
    onButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onRemoveFile: (index: number) => void;
}

export const FileUploadSection: React.FC<FileUploadSectionProps> = ({
    files,
    fileSizeOverLimit,
    fileInputRef,
    onDragEnter,
    onDragLeave,
    onDragOver,
    onDrop,
    onClick,
    onButtonClick,
    onFileInputChange,
    onRemoveFile
}) => {
    const { t } = useTranslation(["cases", "qcprsupport"]);

    return (
        <>
            <InputRow>
                <ChoseFileContainer
                    onDragEnter={onDragEnter}
                    onDragLeave={onDragLeave}
                    onDragOver={onDragOver}
                    onDrop={onDrop}
                    onClick={onClick}>
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={onFileInputChange}
                        multiple
                        style={{ display: 'none' }}
                    />
                    <Button  onClick={onButtonClick} variant="secondary">
                        {t('Take a photo or choose files', { ns: 'qcprsupport' })}
                    </Button>
                </ChoseFileContainer>
            </InputRow>

            <InputRow>
                {files.length > 0 && (
                    <AttachmentsContainer>
                        <AttachmentHeader>
                            <ComponentXS textStyle={ComponentTextStyle.Bold}>
                                {t('ATTACHMENTS')}
                            </ComponentXS>
                            <Tooltip label={t('These attachments can be seen and downloaded by Laerdal Support')} position="top" delay="0">
                                <SystemIcons.Information />
                            </Tooltip>
                        </AttachmentHeader>
                        {fileSizeOverLimit && (
                            <ComponentM color={COLORS.critical_500}>
                                {t('Files too large! Maximum is 20MB')}
                            </ComponentM>
                        )}
                        {files.map((file, index) => (
                            <AttachmentDetails key={index}>
                                <IconButton variant="secondary" action={() => onRemoveFile(index)}>
                                    <SystemIcons.Close color={COLORS.neutral_500} />
                                </IconButton>
                                <ComponentS color={COLORS.neutral_500}>{file.name}</ComponentS>
                            </AttachmentDetails>
                        ))}
                    </AttachmentsContainer>
                )}
            </InputRow>
        </>
    );
};
